import { makeStyles } from "@material-ui/core/styles";
import theme from "../../theme";
 
const useStyles = makeStyles(() => ({
  chipButtonSection: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: "14px",
    // gap: "8px",
    overflow: "hidden",
    // flexWrap: "wrap",
    "& .MuiChip-root": {
      fontSize: "11px",
      height: "32px",
      "& .MuiChip-label": {
        padding: "0 10px",
      },
    },
    [theme.breakpoints.down(1537)]: {
      padding: "10px 8px",
      gap: "6px",
      "& .MuiChip-root": {
        fontSize: "10px",
        height: "28px",
        "& .MuiChip-label": {
          padding: "0 8px",
        },
      },
    },
  },
  notificationListSection: {
    overflow: "auto",
    [theme.breakpoints.down(1537)]: {
      paddingRight: 0,
      marginRight: 0,
    },
  },
}));
 
export default useStyles;
